module.exports = __webpack_public_path__ + "img/26_215.3d4f508b.png";